import {useMutation} from "@tanstack/react-query";
import {changeExpedientCustomerMutationOptions} from "./change-expedient-customer.mutation-options";

export function useChangeExpedientCustomer(id: string) {
  return useMutation(changeExpedientCustomerMutationOptions(id));
}
